import {Group} from './group.model';

export class DepartmentTree {
  rows: Group[] = [];
  private roots: Group[] = [];
  private children: {[id: string]: Group[]} = {};
  private nestedIds = new Set<string>();
  private expanded = new Set<string>();

  setGroups(groups: Group[]): void {
    const ids = new Set(groups.map(group => group.id));
    this.roots = [];
    this.children = {};
    this.nestedIds.clear();
    groups.forEach(group => {
      if (group.parentDepartmentId && ids.has(group.parentDepartmentId)) {
        const siblings = this.children[group.parentDepartmentId] || [];
        siblings.push(group);
        this.children[group.parentDepartmentId] = siblings;
        this.nestedIds.add(group.id);
        return;
      }
      this.roots.push(group);
    });
    this.refreshRows();
  }

  hasChildren(group: Group): boolean {
    return !!this.children[group.id] && !!this.children[group.id].length;
  }

  isChild(group: Group): boolean {
    return this.nestedIds.has(group.id);
  }

  isExpanded(group: Group): boolean {
    return this.expanded.has(group.id);
  }

  toggle(group: Group): void {
    if (this.expanded.has(group.id)) { this.expanded.delete(group.id); }
    else { this.expanded.add(group.id); }
    this.refreshRows();
  }

  private refreshRows(): void {
    this.rows = [];
    this.roots.forEach(group => {
      this.rows.push(group);
      if (this.isExpanded(group)) { this.rows.push(...(this.children[group.id] || [])); }
    });
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/department-tree.ts